module.exports = __webpack_public_path__ + "static/sonnen-51cefce84c371f579016664411ca65e8.mp4";